import { Link } from "react-router-dom";
import { methodSteps } from "@/mocks/site";

export default function MethodSection() {
  return (
    <section id="method" className="scroll-mt-12 w-full border-b border-background-200 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-[11px] font-medium tracking-[0.24em] text-secondary-500">METHOD</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              我们怎么判断一次反转
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              不靠直觉，也不靠声量。每一条归档结论背后都走完同一套流程：先还原顺序，再区分材料与说法，
              然后检查信息在传播链上被改写过几次，最后给结论留一个可以更新的口子。
            </p>
            <Link
              to="/guide"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-800 px-4 py-2.5 text-sm text-foreground-900 transition-colors hover:bg-foreground-900 hover:text-background-50"
            >
              <i className="ri-route-line text-base" aria-hidden="true" />
              阅读完整观察指南
            </Link>
          </div>

          <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8">
            {methodSteps.map((step) => (
              <li
                key={step.no}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className="font-heading text-2xl font-bold text-background-400">{step.no}</span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}